var React = require('react');

function Cycle (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"cycle","d":"M198.9,80.4c65.5,0,118.6,53.1,118.6,118.6s-53.1,118.6-118.6,118.6S80.3,264.6,80.3,199.1c0-65.3,52.7-118.2,117.9-118.6"}));
}

Cycle.defaultProps = {"version":"1.1","baseProfile":"basic","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 398.1 398.1","xmlSpace":"preserve"};

module.exports = Cycle;

Cycle.default = Cycle;
